import QueryString from 'qs'

import type { Brand } from 'modules/products'
import { apiService, createRequestHeadersConfig } from 'shared/api'

const api = apiService()

type QueryProps = {
  page?: string | number
  limit?: string
  sortBy?: string
  order?: string
  category?: string
}

export const getBrandsDictionaryQuery = async (payload: {
  query: QueryProps
  token?: string
}) => {
  const { query = {}, token } = payload
  const params = { page: 1, ...query }

  if (query.category) {
    const response = await api.get(
      `/brands/${query.category}`,
      createRequestHeadersConfig(token)
    )

    return (response as { data: { data: Brand[] } }).data.data
  }

  const response = await api.get(
    `/brands${QueryString.stringify(params, {
      addQueryPrefix: true
    })}`,
    createRequestHeadersConfig(token)
  )

  return (response.data as { data: Brand[] }).data || []
}

type GetBrandsDictionaryNextPagePayload = {
  query: QueryProps
  token?: string
  limit?: number
}

export const getBrandsDictionaryNextPage = async (
  pageParam = 1,
  { query, token, limit = 50 }: GetBrandsDictionaryNextPagePayload
) => {
  const params = { page: pageParam, limit: limit.toString(), ...query }
  const response = await getBrandsDictionaryQuery({ query: params, token })

  return response
}
